import * as r from "react";
import { V as c } from "./ContextIsolator.js";
import "./index.js";
import { C as m, V } from "./CSSMotionList.js";
const x = (s, i, l = void 0) => {
  var t, o;
  const {
    variant: d,
    [s]: e
  } = r.useContext(m), a = r.useContext(c), f = e == null ? void 0 : e.variant;
  let n;
  typeof i < "u" ? n = i : l === !1 ? n = "borderless" : n = (o = (t = a ?? f) !== null && t !== void 0 ? t : d) !== null && o !== void 0 ? o : "outlined";
  const u = V.includes(n);
  return [n, u];
};
export {
  x as u
};
